import { TableComponentV2 } from '@labrav/react-components'
import { OfferRecipients } from '../../../types/flyout'
import { FormikProps } from 'formik'

export const OfferRecipientTable = ({
  offerRecipients,
  formik,
  keyName,
}: {
  offerRecipients: OfferRecipients[]
  formik: FormikProps<Record<string, unknown>>
  keyName?: string
}) => {
  const { values } = formik

  const offerRecipientsFromOffer = (values?.[keyName || 'offerRecipients'] ||
    []) as OfferRecipients[]

  const emailList = offerRecipientsFromOffer.map(recipient => recipient.email)

  const handleChange = (selected: string[]) => {
    const current = offerRecipientsFromOffer
    const tableEmails = offerRecipients.map(r => r.email)

    const manualRecipients = current.filter(r => !tableEmails.includes(r.email))

    const selectedRecipients = offerRecipients.filter(r =>
      selected.includes(r.email)
    )

    const updatedRecipients = [...manualRecipients, ...selectedRecipients]

    formik.setFieldValue(keyName || 'offerRecipients', updatedRecipients)
  }
  const mapping = {
    'First Name': 'firstName',
    'Last Name': 'lastName',
    Title: 'title',
    Email: 'email',
  }

  const objects = offerRecipients.map(recipient => ({
    id: recipient.email,
    firstName: recipient.firstName,
    lastName: recipient.lastName,
    email: recipient.email,
    title: recipient.title,
  }))

  const selectedItems = objects
    ?.filter(recipient => emailList?.includes(recipient.email))
    ?.map(recipient => recipient.email)

  return (
    <div>
      <TableComponentV2
        keyName={keyName || 'offerRecipients'}
        objects={objects}
        mapping={mapping}
        count={offerRecipients?.length || 0}
        fetchMoreData={() => void 0}
        selectedItem={selectedItems}
        onChangeCheckbox={handleChange}
        borderBetweenRows
        isBasicTable
        customCellProps={[
          { style: { width: '22%' } },
          { style: { width: '22%' } },
          { style: { width: '22%' } },
          { style: { width: '34%' } },
        ]}
      />
    </div>
  )
}
